import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/contact/page.tsx");
